let showAccessDenied: (() => void) | null = null;

/** Register the mounted dialog without exposing response payloads to the UI. */
export function registerPlanAccessDenied(handler: () => void): () => void {
  showAccessDenied = handler;
  return () => { if (showAccessDenied === handler) showAccessDenied = null; };
}

export function notifyPlanAccessDenied(status?: number): boolean {
  if (status !== 403) return false;
  showAccessDenied?.();
  return true;
}
